import React, { useState } from "react";
import NewsIcon from "../../assets/images/Collective Talent Interface (1).svg";
import { Card } from "../../components/Card";
import { Button, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TenmplatePopup from "./popups/TenmplatePopup";

function NewsLetterLanding() {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    return (
        <Card>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "85vh",
                    gap: 4,
                    textAlign: "center",
                }}
            >
                <Box
                    component="img"
                    src={NewsIcon}
                    alt="Newsletter Icon"
                    sx={{
                        height: "10rem",
                        width: "10rem",
                    }}
                />
                <Typography variant="h6" color="textPrimary">
                    No Newsletter Templates Added Yet
                </Typography>
                <Typography
                    variant="body1"
                    color="textSecondary"
                    sx={{
                        maxWidth: "60%",
                        margin: "0 auto",
                    }}
                >
                    It looks like you have not created any newsletter templates
                    yet. Start adding newsletter templates and send them to your
                    buddies. It's simple and easy.
                </Typography>

                <Button variant="contained" onClick={() => setOpen(true)}>
                    + Add Newsletter Template
                </Button>
                <TenmplatePopup open={open} onClose={() => setOpen(false)} />
            </Box>
        </Card>
    );
}

export default NewsLetterLanding;
